import React from 'react'
import { useGoogleMapLib } from './hooks'

const GoogleMap = ({ latlng, address, type }) => {
  const ref = React.useRef()

  const onLoad = React.useCallback(() => {
    switch (type) {
      case 'streetview':
        // initialize the geocoder API functions. We need this to convert the address to a geolocation (GPS coordinates)
        const geocoder = new window.google.maps.Geocoder()
        // then we call the geocode function with the address we want to use as parameter
        geocoder.geocode({ address: `${address}, France` }, function(results, status) {
          // set the lookTo const to contain the coordinates of the address entered above
          const lookTo = results[0].geometry.location
          // if the address is found and the geocoder function returned valid coordinates
          if (status === window.google.maps.GeocoderStatus.OK) {
            // set the options for the panorama view
            const panoOptions = {
              position: lookTo,
              panControl: false,
              addressControl: false,
              linksControl: false,
              zoomControlOptions: false
            }
            // initialize a new panorama API object and point to the element with ID streetview as container
            const pano = new window.google.maps.StreetViewPanorama(ref.current, panoOptions)
            // initialize a new streetviewService object
            const service = new window.google.maps.StreetViewService()
            // call the "getPanoramaByLocation" function of the Streetview Services to return the closest streetview position for the entered coordinates
            service.getPanoramaByLocation(pano.getPosition(), 50, function(panoData) {
              if (panoData != null) {
                const panoCenter = panoData.location.latLng
                // this is where the magic happens!
                // the "computeHeading" function calculates the heading with the two GPS coordinates entered as parameters
                const heading = window.google.maps.geometry.spherical.computeHeading(
                  panoCenter,
                  lookTo
                )
                // now we know the heading (camera direction, elevation, zoom, etc) set this as parameters to the panorama object
                const pov = pano.getPov()
                pov.heading = heading
                pov.zoom = 0
                pano.setPov(pov)
              }
            })
          }
        })
        // new window.google.maps.StreetViewPanorama(ref.current, {
        //   position: latlng,
        //   pov: { heading: 165, pitch: 0 },
        //   zoom: 1
        // })
        break

      default:
        const map = new window.google.maps.Map(ref.current, {
          center: latlng,
          zoom: 15,
          mapTypeControl: false,
          streetViewControl: false
        })
        new window.google.maps.Marker({
          map,
          position: latlng
        })
    }
  }, [address, latlng, type])

  useGoogleMapLib(onLoad)

  return <div style={{ height: '100%', width: '100%' }} ref={ref} />
}

export default React.memo(GoogleMap)
